import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import ItemsSearchAddFeild from "../forms/items-search-add-field";
import {
  producBatchDetailsAction,
  producDetailsAction,
  productListAction,
} from "../../redux/actions/general-action";
import { useFormikContext } from "formik";
import { batch, useDispatch } from "react-redux";
import LoadingOverlay from "../helper-components/overlay-loading";
import ItemsInputField from "../forms/items-input-field";
import { url } from "../../redux/config";
import { api } from "../../redux/apis/api";
import moment from "moment";
import errorToast from "../helper-components/error-toast";
import AddButton from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import ChangeBatchField from "./change-batch";
import BatchSelectionModal from "./billing-batch-selection-modal";
import useBarcodeScanner from "../helper-components/helper-function";
import { invoiceScannedItemAction } from "../../redux/actions/invoices-action";

const BillingItemsSection = ({
  initialValues,
  searchRef,
  setSelectedItem,
  selectedItem,
  qtyRef,
  disabled,
  pack_qty_ref,
  is_auto_batch,
  setBatchModalOpen,
  batchModalOpen,
  setLoading,
  billCreateInputs = [],
  createProductPanelOpen,
  setCreateProductPanelOpen,
  isbarcodeScanning = false,
  setIsbarcodeScanning = () => {},
  billingUomMode = "standard_piece",
}) => {
  const disRef = useRef();
  const refillRef = useRef();
  const shrtQtyRef = useRef();
  const [isLoadingOverlay, setIsLoadingOverlay] = useState(false);
  const [heading, setHeading] = useState([]);
  const [batchheading, setBatchHeading] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const billingData = parsed?.find((obj) => obj?.bill_create);
      if (billingData?.bill_create) {
        setHeading(billingData.bill_create);
      }
      const batchData = parsed?.find((obj) => obj?.bill_create_batch_pop_up);
      if (batchData?.bill_create_batch_pop_up) {
        setBatchHeading(batchData.bill_create_batch_pop_up);
      }
    }
  }, []);

  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      let rows = data?.data === null ? [] : data.data;

      if (is_auto_batch) {
        rows = rows.filter(
          (item) =>
            !values?.data?.some(
              (selected) => selected?.item_id === item.item_id
            )
        );
      }

      // rows = rows.map((item) => ({
      //   value: item.item_id,
      //   label: (
      //     <div
      //       style={{
      //         minWidth: "auto",
      //         minHeight: "38px",
      //         display: "grid",
      //         gridTemplateColumns: "10% 20% 20% 20% 6% 6% 6% 6% 6%",
      //         padding: "8px 16px",
      //         alignItems: "center",
      //         fontSize: "var(--items-search-drop-row-fs)",
      //         fontWeight: "var(--items-search-drop-row-fw)",
      //         color: "var(--items-search-drop-row-fg)",
      //       }}
      //     >
      //       <span>{item.item_code}</span>
      //       <span
      //         style={{
      //           maxWidth: "600px",
      //           // minWidth: "600px",

      //           whiteSpace: "wrap",
      //         }}
      //       >
      //         {item.item_name}
      //       </span>
      //       <span>{item.molecule_name || "N/A"}</span>
      //       <span>{item.item_generic_name || "N/A"}</span>
      //       <div className="flex items-center gap-2">
      //         <span
      //           className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${
      //             parseFloat(item?.total_sellable_quantity) > 10
      //               ? "bg-[var(--pill-badge-green-bg)]"
      //               : "bg-[var(--pill-badge-red-bg)]"
      //           }`}
      //         >
      //           {parseFloat(item?.total_sellable_quantity)}
      //         </span>
      //       </div>
      //       <span style={{ textAlign: "center" }}>
      //         {item.item_batch_final_purchase_rate ?? "N/A"}
      //       </span>
      //       <span style={{ textAlign: "center" }}>
      //         {item.tax_rate ?? "N/A"}
      //       </span>
      //       <span style={{ textAlign: "center" }}>
      //         {item.item_selling_price ?? "N/A"}
      //       </span>
      //       <span style={{ textAlign: "center" }}>
      //         {item.item_unit_price ?? "N/A"}
      //       </span>
      //     </div>
      //   ),
      //   item_name: item?.item_name,
      //   availableQty: item?.total_sellable_quantity,
      //   batches: item?.batches?.length,
      // }));

      rows = rows.map((item) => ({
        value: item.item_id,
        label: (
          <div
            style={{
              width: "100%",
              minWidth: "1000px",
              display: "flex",
              alignItems: "center",
              padding: "8px 12px",
              // fontSize: "13px",
              // fontWeight: "400",
              // color: "#374151",
              borderBottom: "1px solid #e5e7eb",
              gap: "12px",
              fontSize: "var(--items-search-drop-row-fs)",
              fontWeight: "var(--items-search-drop-row-fw)",
              color: "var(--items-search-drop-row-fg)",
            }}
          >
            <div
              style={{
                minWidth: "80px",
                maxWidth: "80px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={item.item_code}
            >
              {item.item_code}
            </div>
            <div
              style={{
                minWidth: "120px",
                flex: "1",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                // fontWeight: "500",
              }}
              title={item.item_name}
            >
              {item.item_name}
            </div>
            <div
              style={{
                minWidth: "120px",
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={item.molecule_name || "N/A"}
            >
              {item.molecule_name || "N/A"}
            </div>
            <div
              style={{
                minWidth: "100px",
                maxWidth: "100px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={item.item_generic_name || "N/A"}
            >
              {item.item_generic_name || "N/A"}
            </div>
            <div
              style={{
                minWidth: "80px",
                maxWidth: "80px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <span
                className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${parseFloat(item?.total_sellable_quantity) > 10
                    ? "bg-[var(--pill-badge-green-bg)]"
                    : "bg-[var(--pill-badge-red-bg)]"
                  }`}
              >
                {parseFloat(item?.total_sellable_quantity)}
              </span>
              {/* <span
                style={{
                  backgroundColor:
                    parseFloat(item?.total_sellable_quantity) > 10
                      ? "#dcfce7"
                      : "#fef2f2",
                  color:
                    parseFloat(item?.total_sellable_quantity) > 10
                      ? "#16a34a"
                      : "#dc2626",
                  padding: "2px 6px",
                  borderRadius: "8px",
                  fontSize: "11px",
                  fontWeight: "600",
                  minWidth: "30px",
                  textAlign: "center",
                }}
              >
                {parseFloat(item?.total_sellable_quantity)}
              </span> */}
            </div>
            <div
              style={{
                minWidth: "70px",
                maxWidth: "70px",
                textAlign: "center",
              }}
            >
              {item.item_batch_final_purchase_rate ?? "N/A"}
            </div>
            <div
              style={{
                minWidth: "50px",
                maxWidth: "50px",
                textAlign: "center",
              }}
            >
              {item.tax_rate ?? "N/A"}
            </div>
            <div
              style={{
                minWidth: "70px",
                maxWidth: "70px",
                textAlign: "center",
                // fontWeight: "600",
              }}
            >
              {item.item_selling_price ?? "N/A"}
            </div>
            <div
              style={{
                minWidth: "70px",
                maxWidth: "70px",
                textAlign: "center",
              }}
            >
              {item.item_unit_price ?? "N/A"}
            </div>
          </div>
        ),
        item_name: item?.item_name,
        availableQty: item?.total_sellable_quantity,
        batches: item?.batches?.length,
      }));

      // Add "Create New Product" option at the end
      const createNewProductOption = {
        value: "create_new_product",
        label: (
          <div
            style={{
              minHeight: "38px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 16px",
              fontSize: "var(--items-search-drop-row-fs)",
              fontWeight: "var(--items-search-drop-row-fw)",
              color: "var(--primary)",
              borderTop: "1px solid var(--items-search-drop-border)",
              backgroundColor: "var(--items-search-drop-head-bg)",
            }}
          >
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>+</span>
            <span>Create New Product</span>
          </div>
        ),
        isCreateNew: true,
      };

      setLocalData(data.data);

      // callback([
      //   {
      //     label: (
      //       <div
      //         style={{
      //           display: "grid",
      //           gridTemplateColumns: "10% 20% 20% 20% 6% 6% 6% 6% 6%",

      //           padding: "8px 16px",
      //           position: "sticky",
      //           top: 0,
      //           zIndex: 10,
      //           backgroundColor: "var(--items-search-drop-head-bg)",
      //           color: "var(--items-search-drop-head-fg)",
      //           fontWeight: "var(--items-search-drop-head-fw)",
      //           fontSize: "var(--items-search-drop-head-fs)",
      //           borderBottom: "1px solid var(--items-search-drop-border)",
      //           alignItems: "center",
      //           height: "38px",
      //         }}
      //       >
      //         <span>Item Code</span>
      //         <span>Item Name</span>
      //         <span>Molecule Name</span>
      //         <span>Generic Name</span>

      //         <span style={{ textAlign: "center" }}>Avil Qty</span>
      //         <span style={{ textAlign: "center" }}>Pur Price</span>
      //         <span style={{ textAlign: "center" }}>GST %</span>
      //         <span style={{ textAlign: "center" }}>Rate</span>
      //         <span style={{ textAlign: "center" }}>MRP</span>
      //       </div>
      //     ),
      //     options: rows,
      //   },
      // ]);
      callback([
        {
          label: (
            <div
              style={{
                width: "100%",
                minWidth: "1000px",
                display: "flex",
                alignItems: "center",
                padding: "10px 12px",
                position: "sticky",
                top: 0,
                zIndex: 10,
                backgroundColor: "var(--items-search-drop-head-bg, #f8fafc)",
                color: "var(--items-search-drop-head-fg, #374151)",
                fontWeight: "var(--items-search-drop-head-fw, 600)",
                fontSize: "var(--items-search-drop-head-fs, 13px)",
                borderBottom:
                  "2px solid var(--items-search-drop-border, #d1d5db)",
                height: "40px",
                gap: "12px",
              }}
            >
              <div style={{ minWidth: "80px", maxWidth: "80px" }}>
                Item Code
              </div>
              <div style={{ minWidth: "150px", flex: "1" }}>Item Name</div>
              <div style={{ minWidth: "120px", maxWidth: "120px" }}>
                Molecule Name
              </div>
              <div style={{ minWidth: "100px", maxWidth: "100px" }}>
                Generic Name
              </div>
              <div
                style={{
                  minWidth: "80px",
                  maxWidth: "80px",
                  textAlign: "center",
                }}
              >
                Avail Qty
              </div>
              <div
                style={{
                  minWidth: "70px",
                  maxWidth: "70px",
                  textAlign: "center",
                }}
              >
                Pur Price
              </div>
              <div
                style={{
                  minWidth: "50px",
                  maxWidth: "50px",
                  textAlign: "center",
                }}
              >
                GST %
              </div>
              <div
                style={{
                  minWidth: "70px",
                  maxWidth: "70px",
                  textAlign: "center",
                }}
              >
                Rate
              </div>
              <div
                style={{
                  minWidth: "70px",
                  maxWidth: "70px",
                  textAlign: "center",
                }}
              >
                MRP
              </div>
            </div>
          ),
          options: [...rows, createNewProductOption],
        },
      ]);
    };

    const onError = () => { };

    if (inputValue?.length > 0) {
      dispatch(
        productListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };
  // AUTO BATCHING CALCULATION

  const handleQuantityChange = async (
    item_batch_number,
    qty,
    item,
    item_refill_days,
    item_shortage_qty,
    values
  ) => {
    const baseIndex = values?.data?.length - 1;
    let updatedData = [...(values?.data ?? [])];
    updatedData = updatedData.filter(
      (existingItem) =>
        existingItem.item_batch_number !== item_batch_number ||
        existingItem.item_id !== item.item_id
    );
    // In billing UOM mode, convert user-entered qty (in billing UOM units) to base units for the stock API
    const billingBaseQtyForStock = item?.billing_base_quantity;
    const stockQty = billingBaseQtyForStock ? parseFloat(qty) * billingBaseQtyForStock : qty;
    const stockApiUrl = `${url}/v1/inventory/stock/items?item_id=${item.item_id}&item_quantity=${stockQty}&cmr_phone_number=${values?.phone?.label}&item_discount_percentage=${values?.tempRowData?.item_discount_percentage}`;
    if (parseFloat(qty) > 0) {
      try {
        const stockApiResponse = await api.get(stockApiUrl);
        const rawBatchDetail = stockApiResponse?.data?.data?.itemDetails;
        if (
          stockApiResponse?.data?.code === 200 &&
          rawBatchDetail?.length > 0
        ) {
          // Merge fulfilled batches with the same batch number
          // (stock API can return multiple entries per batch when stock is across multiple bin locations)
          const mergedBatchMap = {};
          for (const batch of rawBatchDetail) {
            const key = batch.batchNumber;
            if (mergedBatchMap[key]) {
              mergedBatchMap[key].quantity = parseFloat(mergedBatchMap[key].quantity) + parseFloat(batch.quantity);
              mergedBatchMap[key].item_discount_amount = (parseFloat(mergedBatchMap[key].item_discount_amount) + parseFloat(batch.item_discount_amount)).toString();
              mergedBatchMap[key].item_tax_amount = parseFloat(mergedBatchMap[key].item_tax_amount) + parseFloat(batch.item_tax_amount);
            } else {
              mergedBatchMap[key] = { ...batch, quantity: parseFloat(batch.quantity) };
            }
          }
          const batchDetail = Object.values(mergedBatchMap);
          const itemBatchList = stockApiResponse.data.data?.itemBatchList;

          for (
            let itemDetailIndex = 0;
            itemDetailIndex < batchDetail.length;
            itemDetailIndex++
          ) {
            const itemDetail = batchDetail[itemDetailIndex];
            const updatedRowIndex = baseIndex + itemDetailIndex;
            // Apply billing UOM conversion: multiply per-piece price by billing base qty
            // and convert API quantities (base units) back to billing UOM units for display
            const autoBatchBillingBaseQty = item?.billing_base_quantity;
            const effectiveUnitPrice = autoBatchBillingBaseQty
              ? parseFloat(itemDetail?.item_unit_price) * autoBatchBillingBaseQty
              : parseFloat(itemDetail?.item_unit_price);
            // Convert quantity from base units to billing UOM units for display
            const displayQty = autoBatchBillingBaseQty
              ? parseFloat(itemDetail?.quantity) / autoBatchBillingBaseQty
              : parseFloat(itemDetail?.quantity);
            const total_amount = (
              effectiveUnitPrice *
              displayQty -
              parseFloat(itemDetail?.item_discount_amount)
            )?.toFixed(2);
            const item_final_price = (
              total_amount / displayQty || 0
            ).toFixed(2);

            // COMMENTED OUT: item_margin_percentage calculation - should use backend value
            // const item_margin_percentage =
            //   (
            //     ((parseFloat(item_final_price) -
            //       parseFloat(itemDetail?.item_batch_final_purchase_rate)) /
            //       parseFloat(item_final_price)) *
            //     100
            //   ).toFixed(2) || 0;
            const updatedDataRow = {
              ...item,
              item_loose_qty: displayQty,
              item_discount_amount: itemDetail?.item_discount_amount,
              item_tax_amount: itemDetail?.item_tax_amount.toFixed(2),
              item_discount_percentage:
                itemDetail?.item_discount_percentage || 0,
              item_unit_price: effectiveUnitPrice,
              item_pack_price: effectiveUnitPrice,
              item_price_wiithout_tax: (
                effectiveUnitPrice *
                displayQty -
                parseFloat(itemDetail?.item_discount_amount) -
                parseFloat(itemDetail?.item_tax_amount) || 0
              ).toFixed(2),
              item_batch_number: itemDetail?.batchNumber,
              item_rack_location: itemDetail?.item_rack_location,
              item_batch_final_purchase_rate:
                itemDetail?.item_batch_final_purchase_rate || 0,
              item_exp_date: moment(itemDetail?.expiryDate).format(
                "YYYY-MM-DD"
              ),
              to_bin_id: itemDetail?.to_bin_id,
              quantity: displayQty,
              instock: true,
              item_gst: itemDetail?.item_total_tax_percentage,
              item_sgst: (parseFloat(itemDetail?.item_tax_amount) / 2).toFixed(
                2
              ),
              item_cgst: (parseFloat(itemDetail?.item_tax_amount) / 2).toFixed(
                2
              ),
              item_igst: 0,
              item_final_price: item_final_price || 0,
              item_margin_percentage:
                parseFloat(itemDetail?.margin_percentage) || 0,
              item_total_amount: total_amount || 0,
              itemBatchList: itemBatchList ?? [],
              item_total_tax_percentage: itemDetail?.item_total_tax_percentage,
              minDiscountPercentage:
                parseFloat(itemDetail?.minDiscountPercentage) || 0,
              maxDiscountPercentage:
                parseFloat(itemDetail?.maxDiscountPercentage) || 0,
              item_refill_days: item_refill_days,
              item_shortage_qty: item_shortage_qty,
              is_predefined_dis:
                parseFloat(itemDetail?.item_discount_percentage) > 0,
              is_store_added_item: false,
            };

            updatedData.splice(updatedRowIndex, 0, updatedDataRow);
          }

          const sot_total_gst = updatedData.reduce(
            (total, item) => total + parseFloat(item?.item_tax_amount || 0),
            0
          );

          const sot_total_discount = updatedData.reduce(
            (total, item) =>
              total + parseFloat(item?.item_discount_amount || 0),
            0
          );

          const sot_sub_total = updatedData.reduce(
            (subtotal, item) =>
              subtotal +
              parseFloat(item?.item_unit_price || 0) *
              parseFloat(item?.quantity || 0),
            0
          );

          const sot_total_amount = updatedData.reduce(
            (total, item) => total + parseFloat(item?.item_total_amount || 0),
            0
          );

          console.log(sot_total_amount, "fgfdgdfgfgdfgdg");
          const rounded_total = Math.round(sot_total_amount);
          const roundoff = (rounded_total - sot_total_amount)?.toFixed(2);
          console.log(rounded_total, "fgfdgdfgfgdfgdg");

          console.log(roundoff, "fgfdgdfgfgdfgdg");

          setFieldValue("data", updatedData);
          setFieldValue("tempRowData", initialValues?.tempRowData);
          setFieldValue("sot_total_gst", sot_total_gst.toFixed(2));
          setFieldValue("sot_total_discount", sot_total_discount.toFixed(2));
          setFieldValue("sot_sub_total", sot_sub_total.toFixed(2));
          setFieldValue("sot_total_amount", rounded_total.toFixed(2));
          setFieldValue("sot_round_off_value", roundoff);
          setFieldValue("sot_invoice_discount", 0);
          setFieldValue("sot_invoice_discount_percentage", 0);
          setFieldValue("sot_is_invoice_dis_percentage", true);
          setFieldValue("header_inv_dis_per", "");
          setIsLoadingOverlay(false);
          if (searchRef && searchRef.current) {
            setTimeout(() => {
              searchRef.current.focus();
            }, 0);
          }
          setSelectedItem({ itemid: "", index: null, item_name: "" });
        } else {
          errorToast(
            `Product ${item.item_name} with quantity ${qty} is not available`
          );
          setIsLoadingOverlay(false);
          qtyRef.current.focus();
        }
      } catch (error) {
        if (error?.response?.data?.data?.itemDetails?.item_sellable_quantity) {
          errorToast(
            `${item.item_name} available quantity is ${error?.response?.data?.data?.itemDetails?.item_sellable_quantity}`
          );
        } else {
          errorToast(error?.response?.data?.message ?? "Something went wrong");
        }
        setIsLoadingOverlay(false);
        qtyRef.current.focus();
      }
    } else {
      errorToast("Quantity should be greater than 0");
      setIsLoadingOverlay(false);
    }
  };

  const removeRow = (rowIndex, type = "") => {
    let updatedData = [...values.data];

    if (type === "all") {
      updatedData = [];
    } else {
      updatedData.splice(rowIndex, 1);
    }
    setFieldValue("data", updatedData);
    const sot_total_gst = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_tax_amount || 0),
      0
    );

    const sot_total_discount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_discount_amount || 0),
      0
    );

    const sot_sub_total = updatedData.reduce(
      (subtotal, item) => subtotal + parseFloat(item?.item_unit_price || 0),
      0
    );

    const sot_total_amount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_total_amount || 0),
      0
    );

    const rounded_total = Math.round(sot_total_amount);
    const roundoff = (rounded_total - sot_total_amount).toFixed(2);
    setFieldValue("sot_total_gst", sot_total_gst.toFixed(2));
    setFieldValue("sot_total_discount", sot_total_discount.toFixed(2));
    setFieldValue("sot_sub_total", sot_sub_total.toFixed(2));
    setFieldValue("sot_total_amount", rounded_total.toFixed(2));
    setFieldValue("sot_round_off_value", roundoff);
    setFieldValue("sot_invoice_discount", 0);
    setFieldValue("sot_invoice_discount_percentage", 0);
    setFieldValue("sot_is_invoice_dis_percentage ", true);
    setFieldValue("header_inv_dis_per ", 0);
  };

  const getBillingUomBaseQuantity = (uomDropdown, billingUomNameId) => {
    if (
      billingUomMode !== "billing_uom_from_product" ||
      !billingUomNameId ||
      !uomDropdown?.length
    )
      return null;
    const matched = uomDropdown.find(
      (uom) => uom?.item_id === billingUomNameId
    );
    return matched ? parseFloat(matched?.base_quantity) || null : null;
  };

  const onSuccessDetails = (data, filteredData) => {
    setIsLoadingOverlay(false);
    const uomDropdown = data?.data?.uom_dropdown ?? [];
    const billingUomNameId = data?.data?.item_billing_uom_name_id;
    const billingBaseQty = getBillingUomBaseQuantity(uomDropdown, billingUomNameId);
    const billingUomName = billingBaseQty
      ? uomDropdown.find((u) => u?.item_id === billingUomNameId)?.alt_uom ?? ""
      : "";
    const totalSellable = data?.data?.total_sellable_quantity ?? 0;

    const updatedTempRowData = {
      ...filteredData,
      item_uom: billingUomName || data?.data?.item_uom || "",
      uom_dropdown: uomDropdown,
      total_sellable_quantity: billingBaseQty
        ? Math.floor(totalSellable / billingBaseQty)
        : totalSellable,
      billing_base_quantity: billingBaseQty || null,
      item_billing_uom_name: data?.data?.item_billing_uom_name || null,
      item_billing_uom_name_id: billingUomNameId || null,
    };
    setFieldValue("tempRowData", updatedTempRowData);
    qtyRef.current.focus();
  };
  const onSuccessBatchDetails = (data, filteredData) => {
    setIsLoadingOverlay(false);
    const batchList = data?.data || [];
    const firstBatch = batchList[0];
    // Billing UOM data comes directly from backend join
    const billingBaseQtyFromBatch =
      billingUomMode === "billing_uom_from_product" && firstBatch?.billing_uom_base_quantity
        ? parseFloat(firstBatch.billing_uom_base_quantity)
        : null;
    const updatedTempRowData = {
      ...filteredData,
      item_Batch_List: batchList,
      billing_base_quantity: billingBaseQtyFromBatch || null,
      item_billing_uom_name: firstBatch?.item_billing_uom_name || null,
      item_billing_uom_name_id: firstBatch?.item_billing_uom_name_id || null,
      item_uom: billingBaseQtyFromBatch
        ? firstBatch?.billing_uom_alt_uom ?? filteredData?.item_uom ?? ""
        : filteredData?.item_uom ?? "",
    };
    setFieldValue("tempRowData", updatedTempRowData);
    setBatchModalOpen(true);
  };

  const onErrorDetails = (data) => {
    setIsLoadingOverlay(false);
  };

  const onSuccessScanned = (data) => {
    const items = data?.data;
    if (!items || items.length === 0) {
      setIsbarcodeScanning(false);
      errorToast("No product found for scanned barcode");
      return;
    }
    const foundItem = items[0];

    // Check if item already exists in the table
    if (
      is_auto_batch &&
      values?.data?.some((row) => row?.item_id === foundItem?.item_id)
    ) {
      setIsbarcodeScanning(false);
      errorToast(
        "Item already added to invoice. Please adjust quantity if you wish to add more."
      );
      return;
    }

    // Check if item has negative or 0 available quantity
    const availableQty = parseFloat(foundItem?.total_sellable_quantity || 0);
    if (availableQty <= 0) {
      setIsbarcodeScanning(false);
      errorToast("Scanned item has no available stock");
      return;
    }

    setIsLoadingOverlay(true);

    const mappedItem = {
      item_code: foundItem.item_code,
      item_name: foundItem.item_name,
      total_sellable_quantity: 0,
      quantity: "",
      item_free_quantity: 0,
      item_uom: "",
      item_batch_number: "",
      item_exp_date: "",
      item_rack_location: foundItem?.item_rack_location || "",
      item_manufacturer_name: foundItem.item_manufacturer_name,
      item_schedule: foundItem?.item_schedule || "",
      item_hsn: foundItem?.item_hsn ?? "",
      item_unit_price: 0.0,
      item_price_wiithout_tax: 0.0,
      item_discount_amount: 0.0,
      item_discount_percentage: "",
      item_tax_amount: 0.0,
      item_gst: 0,
      item_final_price: 0.0,
      item_margin_percentage: 0.0,
      item_total_amount: 0.0,
      item_id: foundItem?.item_id,
      item_total_tax_percentage: 0,
      instock: true,
      item_manufacturer_id: foundItem.item_manufacturer,
      item_uom_id: foundItem.item_uom,
      item_generic_name: foundItem?.item_generic_name,
      molecule_name: foundItem?.molecule_name,
    };

    let actionType = producBatchDetailsAction;
    if (is_auto_batch) {
      actionType = producDetailsAction;
    }

    dispatch(
      actionType(
        {
          item_id: mappedItem?.item_id,
          item_uom: mappedItem?.item_uom_id,
        },
        (detailData) => {
          if (is_auto_batch) {
            onSuccessDetails(detailData, mappedItem);
          } else {
            onSuccessBatchDetails(detailData, mappedItem);
          }
          setIsbarcodeScanning(false);
        },
        (errData) => {
          onErrorDetails(errData);
          setIsbarcodeScanning(false);
        }
      )
    );
  };

  const onErrorScanned = (data) => {
    setIsbarcodeScanning(false);
    errorToast(data?.data?.message ?? "Failed to add scanned item");
  };

  useBarcodeScanner((barcode) => {
    if (barcode && !disabled) {
      setIsbarcodeScanning(true);
      dispatch(
        invoiceScannedItemAction(barcode, onSuccessScanned, onErrorScanned)
      );
    }
  });

  // MANUAL BATCHING CALCULATION
  const calculateItemPriceDetails = async (item) => {
    let updatedData = [...(values?.data ?? [])];
    const discount_percentage = parseFloat(item?.item_discount_percentage) || 0;
    const quantity = parseFloat(item?.quantity || 0);
    const rawUnitPrice = parseFloat(item?.item_unit_price);
    const unit_price = isNaN(rawUnitPrice)
      ? 0
      : parseFloat(rawUnitPrice.toFixed(2));
    const purchase_rate =
      (
        parseFloat(item?.item_batch_final_purchase_rate || 0) /
        parseFloat(item?.item_pack_size || 0)
      ).toFixed(2) || 0;
    const gst_rate = parseFloat(item?.item_gst || 0);
    const maxDiscountPercentage = parseFloat(item?.maxDiscountPercentage || 0);
    const minDiscountPercentage = parseFloat(item?.minDiscountPercentage || 0);
    const totalAmountOfItem = parseFloat(unit_price) * quantity;
    const discountAmount = (totalAmountOfItem * discount_percentage) / 100;
    const discountedAmount = totalAmountOfItem - discountAmount;

    const taxAmount =
      discountedAmount - (discountedAmount * 100) / (100 + gst_rate);

    const item_total_amount = discountedAmount.toFixed(2);
    const item_final_price = (discountedAmount / quantity || 0).toFixed(2);
    console.log(item_final_price, purchase_rate, "fdgfdgdfgdfgdfgdfgdfgdgdfg");
    console.log(item_final_price, purchase_rate, "fdgfdgdfgdfgdfgdfgdfgdgdfg");

    // COMMENTED OUT: item_margin_percentage calculation - should use backend value
    // const margin =
    //   ((parseFloat(item_final_price) - purchase_rate) / item_final_price) * 100;
    // const item_margin_percentage = isFinite(margin)
    //   ? margin.toFixed(2)
    //   : "0.00";

    const updatedDataRow = {
      ...item,
      item_discount_amount: parseFloat(discountAmount.toFixed(2)),
      item_tax_amount: parseFloat(taxAmount.toFixed(2)),
      item_discount_percentage: discount_percentage || "",
      item_unit_price: unit_price.toFixed(2),
      item_pack_price: parseFloat(item?.item_pack_price),
      item_price_wiithout_tax: (discountedAmount - taxAmount || 0).toFixed(2),
      item_batch_number: item?.item_batch_number || "",
      item_rack_location: item?.item_rack_location || "",
      // item_batch_final_purchase_rate: purchase_rate || 0,
      item_exp_date: moment(item?.item_exp_date).format("YYYY-MM-DD"),
      quantity,
      instock: true,
      item_gst: gst_rate.toFixed(2),
      item_sgst: (taxAmount / 2).toFixed(2),
      item_cgst: (taxAmount / 2).toFixed(2),
      item_igst: "0",
      item_final_price: item_final_price || 0,
      item_margin_percentage: item?.margin_percentage || 0, // This should come from itemDetails array
      item_total_amount: item_total_amount ?? 0,
      item_total_tax_percentage: gst_rate.toFixed(2),
      item_refill_days: item?.item_refill_days,
      item_shortage_qty: item?.item_shortage_qty,
      minDiscountPercentage,
      maxDiscountPercentage,
      is_predefined_dis: discount_percentage > 0,
      is_store_added_item: false,
    };
    updatedData = updatedData.filter(
      (existingItem) =>
        !(
          existingItem.item_id === item.item_id &&
          existingItem.item_batch_number === item?.item_batch_number &&
          existingItem.item_rack_location === item?.item_rack_location
        )
    );
    updatedData.push(updatedDataRow);
    const sot_total_gst = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_tax_amount || 0),
      0
    );

    const sot_total_discount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_discount_amount || 0),
      0
    );

    const sot_sub_total = updatedData.reduce(
      (subtotal, item) =>
        subtotal +
        parseFloat(item?.item_unit_price || 0) *
        parseFloat(item?.quantity || 0),
      0
    );

    const sot_total_amount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_total_amount || 0),
      0
    );

    const rounded_total = Math.round(sot_total_amount);
    const roundoff = (rounded_total - sot_total_amount)?.toFixed(2);

    // Set updated fields
    setFieldValue("data", updatedData);
    setFieldValue("tempRowData", initialValues?.tempRowData);
    setFieldValue("sot_total_gst", sot_total_gst.toFixed(2));
    setFieldValue("sot_total_discount", sot_total_discount.toFixed(2));
    setFieldValue("sot_sub_total", sot_sub_total.toFixed(2));
    setFieldValue("sot_total_amount", rounded_total.toFixed(2));
    setFieldValue("sot_round_off_value", roundoff);
    setFieldValue("sot_invoice_discount", 0);
    setFieldValue("sot_invoice_discount_percentage", 0);
    setFieldValue("sot_is_invoice_dis_percentage", true);
    setFieldValue("header_inv_dis_per", "");
    setIsLoadingOverlay(false);
    if (searchRef && searchRef.current) {
      setTimeout(() => {
        searchRef.current.focus();
      }, 0);
    }
  };

  const baseWidths = {
    item_code: 6,
    item_name: 15,
    item_name_search: 15,
    molecule_name: 15,
    item_generic_name: 15,
    item_batch_number: 10,
    item_uom: 7,
    total_sellable_quantity: 7,
    item_pack_qty: 7,
    item_loose_qty: 7,
    item_discount_percentage: 9,
    item_refill_days: 7,
    item_shortage_qty: 7,
  };

  // Memoize enabledFields and totalVisibleWidth for performance
  const enabledFields = useMemo(
    () => billCreateInputs.filter((h) => h.enabled && baseWidths[h.value]),
    [billCreateInputs]
  );
  const totalVisibleWidth = useMemo(
    () => enabledFields.reduce((acc, h) => acc + baseWidths[h.value], 0),
    [enabledFields]
  );
  const getAdjustedWidth = useCallback(
    (field) => (baseWidths[field] / totalVisibleWidth) * 95,
    [totalVisibleWidth]
  );

  return (
    <div
      style={{
        maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
        height: "auto", // Let it grow naturally to fit its content
      }}
      className={`border border-[var(--create-table-main-border)] border-1 border-radius px-3 pb-3`}
    >
      {!disabled && (
        <div
          key={enabledFields.map((f) => f.value).join(",")}
          className="flex items-center justify-between w-full h-[5.5rem] gap-2"
        >
          {console.log("enabledFields", enabledFields)}
          {enabledFields.map((heading, index) => {
            console.log("heading", heading);
            if (!heading.enabled) return null; // <-- skip rendering if not enabled
            const fieldValue = heading?.value;
            const widthPercent = getAdjustedWidth(fieldValue);

            if (
              fieldValue === "item_code" ||
              fieldValue === "item_name" ||
              fieldValue === "item_name_search" ||
              fieldValue === "molecule_name" ||
              fieldValue === "item_generic_name"
            ) {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  key={fieldValue}
                  className={
                    fieldValue === "item_code"
                      ? `max-w-[${widthPercent}%] min-w-[${widthPercent}%]`
                      : `max-w-[${widthPercent}%] min-w-[${widthPercent}%]`
                  }
                >
                  <ItemsSearchAddFeild
                    label={heading.label}
                    isDisabled={disabled}
                    searchRef={heading.value === "item_code" ? searchRef : {}}
                    isLabelReq={true}
                    menuPlacement="auto"
                    optionPadding={0}
                    menuWidth="65rem"
                    errorClass="hidden"
                    isRequired={false}
                    value={
                      values?.tempRowData?.[heading.value]
                        ? {
                          label: values?.tempRowData?.[heading.value],
                          value: values?.tempRowData?.[heading.value],
                        }
                        : null
                    }
                    name={`tempRowData.${heading.value}`}
                    field={heading.value}
                    defaultSelectClass=""
                    placeholder={heading.label}
                    fetchData={fetchData}
                    onChange={async (selectedOption) => {
                      // Check if "Create New Product" was selected
                      if (
                        selectedOption?.isCreateNew ||
                        selectedOption?.value === "create_new_product"
                      ) {
                        setCreateProductPanelOpen(true);
                        return;
                      }

                      setIsLoadingOverlay(true);
                      setFieldValue(
                        `tempRowData.${heading.value}`,
                        selectedOption.label
                      );
                      const foundItem = localData?.find(
                        (item) => item?.item_id === selectedOption?.value
                      );

                      // Check if item has negative or 0 available quantity
                      const availableQty = parseFloat(
                        foundItem?.total_sellable_quantity || 0
                      );
                      if (availableQty <= 0) {
                        // Pre-load the create product panel with existing item data
                        const preloadedData = {
                          item_id: foundItem?.item_id,
                          item_code: foundItem?.item_code,
                          item_name: foundItem?.item_name,
                          item_generic_name: foundItem?.item_generic_name,
                          item_hsn: foundItem?.item_hsn,
                          item_manufacturer: foundItem?.item_manufacturer,
                          item_schedule: foundItem?.item_schedule,
                          item_uom: foundItem?.item_uom,
                          item_unit_price: foundItem?.item_unit_price,
                          item_selling_price: foundItem?.item_selling_price,
                          item_tax_rate: foundItem?.tax_rate,
                          item_pack_size: foundItem?.item_pack_size,
                          item_rack_location: foundItem?.item_rack_location,
                          item_manufacturer_name:
                            foundItem?.item_manufacturer_name,
                          item_manufacturer_id: foundItem?.item_manufacturer,
                          item_uom_id: foundItem?.item_uom_id,
                          molecule_name: foundItem?.molecule_name,
                          item_margin_percentage:
                            foundItem?.margin_percentage || 0,
                          uom_dropdown: foundItem?.uom_dropdown || [],
                          is_existing_item: true, // Flag to indicate this is an existing item
                        };

                        // Set the preloaded data in tempRowData
                        setFieldValue("tempRowData", preloadedData);

                        // Set only the essential fields for existing item handling
                        setFieldValue("existing_item_id", foundItem?.item_id);
                        setFieldValue(
                          "existing_item_code",
                          foundItem?.item_code
                        );
                        setFieldValue(
                          "existing_molecule_name",
                          foundItem?.molecule_name
                        );
                        setFieldValue(
                          "existing_item_generic_name",
                          foundItem?.item_generic_name
                        );

                        // Open create product panel
                        setCreateProductPanelOpen(true);
                        setIsLoadingOverlay(false);
                        return;
                      }

                      const mappedItem = foundItem
                        ? {
                          item_code: foundItem.item_code,
                          item_name: foundItem.item_name,
                          total_sellable_quantity: 0,
                          quantity: "",
                          item_free_quantity: 0,
                          item_uom: "",
                          item_batch_number: "",
                          item_exp_date: "",
                          item_rack_location:
                            foundItem?.item_rack_location || "",
                          item_manufacturer_name:
                            foundItem.item_manufacturer_name,
                          item_schedule: foundItem?.item_schedule || "",
                          item_hsn: foundItem?.item_hsn ?? "",
                          item_unit_price: 0.0,
                          item_price_wiithout_tax: 0.0,
                          item_discount_amount: 0.0,
                          item_discount_percentage: "",
                          item_tax_amount: 0.0,
                          item_gst: 0,
                          item_final_price: 0.0,
                          item_margin_percentage: 0.0,
                          item_total_amount: 0.0,
                          item_id: foundItem?.item_id,
                          item_total_tax_percentage: 0,
                          instock: true,
                          item_manufacturer_id: foundItem.item_manufacturer,
                          item_uom_id: foundItem.item_uom,
                          item_generic_name: foundItem?.item_generic_name,
                          molecule_name: foundItem?.molecule_name,
                        }
                        : null;

                      let actionType = producBatchDetailsAction;
                      if (is_auto_batch) {
                        actionType = producDetailsAction;
                      }

                      dispatch(
                        actionType(
                          {
                            item_id: mappedItem?.item_id,
                            item_uom: mappedItem?.item_uom_id,
                          },
                          (data) => {
                            if (is_auto_batch) {
                              onSuccessDetails(data, mappedItem);
                            } else {
                              onSuccessBatchDetails(data, mappedItem);
                            }
                          },
                          onErrorDetails
                        )
                      );
                    }}
                  />
                </div>
              );
            }

            if (fieldValue === "item_batch_number") {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  onClick={() => {
                    if (values?.tempRowData?.item_name && !is_auto_batch) {
                      setBatchModalOpen(true);
                    }
                  }}
                  className={`min-w-[10%] max-w-[10%] cursor-pointer`}
                >
                  <div style={{ pointerEvents: "none" }}>
                    <ItemsInputField
                      disabled={true}
                      name={`tempRowData.item_batch_number`}
                      label="Batch Number"
                      isLabelReq={true}
                      placeholder="Batch no"
                    />
                  </div>
                </div>
              );
            }

            if (
              fieldValue === "item_uom" ||
              fieldValue === "total_sellable_quantity"
            ) {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  key={fieldValue}
                  className="max-w-[7%] min-w-[7%]"
                >
                  <ItemsInputField
                    disabled={true}
                    name={`tempRowData.${fieldValue}`}
                    label={heading.label}
                    isLabelReq={true}
                    placeholder={heading.label}
                  />
                </div>
              );
            }

            if (fieldValue === "item_pack_qty") {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  className={"max-w-[7%]"}
                >
                  <ItemsInputField
                    ref={pack_qty_ref}
                    type="numer"
                    max={parseFloat(values?.tempRowData?.max_pack_qty)}
                    disabled={disabled || is_auto_batch}
                    name={`tempRowData.item_pack_qty`}
                    label="Pack"
                    isLabelReq={true}
                    placeholder="Qty"
                    onChange={(e) => {
                      setFieldValue("tempRowData.item_loose_qty", "");
                      const inputVal = parseFloat(e.target.value);
                      const maxQty = parseFloat(
                        values?.tempRowData?.max_pack_qty
                      );
                      const baseQty = parseFloat(
                        values?.tempRowData?.item_pack_size || 0
                      );
                      if (inputVal > maxQty) {
                        errorToast(
                          `Cannot exceed Avail pack qty ${values?.tempRowData?.max_pack_qty}`
                        ); // ✅ show error toast
                        setFieldValue("tempRowData.item_pack_qty", maxQty); // ✅ reset to max
                        setFieldValue("tempRowData.quantity", maxQty * baseQty);
                      } else {
                        setFieldValue(
                          "tempRowData.item_pack_qty",
                          inputVal || ""
                        ); // ✅ set normally
                        setFieldValue(
                          "tempRowData.quantity",
                          inputVal * baseQty
                        );
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        qtyRef?.current?.focus();
                      }
                    }}
                  />
                </div>
              );
            }

            if (fieldValue === "item_loose_qty") {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  className={"max-w-[7%]"}
                >
                  <ItemsInputField
                    disabled={disabled}
                    ref={qtyRef}
                    name={`tempRowData.item_loose_qty`}
                    label="Loose"
                    isLabelReq={true}
                    placeholder="Qty"
                    max={
                      parseFloat(
                        values?.tempRowData?.total_sellable_quantity || 0
                      ) -
                      parseInt(values?.tempRowData?.item_pack_qty || 0) *
                      parseFloat(values?.tempRowData?.item_pack_size || 0)
                    }
                    onChange={(e) => {
                      const inputVal = parseFloat(e.target.value);
                      const totalSellable = parseFloat(
                        values?.tempRowData?.total_sellable_quantity || 0
                      );
                      const packQty = parseInt(
                        values?.tempRowData?.item_pack_qty || 0
                      );
                      const baseQty = parseFloat(
                        values?.tempRowData?.item_pack_size || 0
                      );
                      const maxQty = totalSellable - packQty * baseQty;

                      if (inputVal > maxQty) {
                        errorToast(`Cannot exceed Avail Loose qty ${maxQty}`); // ✅ show error toast
                        setFieldValue("tempRowData.item_loose_qty", maxQty);
                        setFieldValue(
                          "tempRowData.quantity",
                          maxQty + baseQty * packQty
                        );
                      } else {
                        setFieldValue(
                          "tempRowData.item_loose_qty",
                          inputVal || ""
                        );
                        setFieldValue(
                          "tempRowData.quantity",
                          inputVal + baseQty * packQty
                        );
                      }
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Tab" || event.key === "Enter") {
                        if (index === enabledFields?.length - 1) {
                          event.preventDefault(); // Prevent default behavior
                          setIsLoadingOverlay(true);
                          if (is_auto_batch) {
                            handleQuantityChange(
                              values?.tempRowData?.item_batch_number,
                              values?.tempRowData?.item_loose_qty,
                              values?.tempRowData,
                              values?.tempRowData?.item_refill_days,
                              values?.tempRowData?.item_shortage_qty,
                              values
                            );
                          } else {
                            calculateItemPriceDetails(values?.tempRowData);
                          }
                        } else {
                          event.preventDefault(); // <=== Add this line here to stop default tab
                          if (disRef?.current) {
                            disRef.current.focus();
                          } else if (refillRef?.current) {
                            refillRef.current.focus();
                          } else if (shrtQtyRef?.current) {
                            shrtQtyRef.current.focus();
                          }
                        }
                      }
                    }}
                  />
                </div>
              );
            }

            if (fieldValue === "item_discount_percentage") {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  className={"max-w-[9%]"}
                >
                  <ItemsInputField
                    type="number"
                    disabled={disabled}
                    ref={disRef}
                    name={`tempRowData.item_discount_percentage`}
                    label="Discount (%)"
                    isLabelReq={true}
                    placeholder="Disc"
                    onChange={(e) => {
                      let value = parseFloat(e.target.value);

                      // Auto-correct if value exceeds limits
                      if (value < 0) {
                        value = 0;
                        e.target.value = 0;
                      } else if (value > 100) {
                        value = 100;
                        e.target.value = 100;
                      }

                      setFieldValue(
                        "tempRowData.item_discount_percentage",
                        value
                      );
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Tab" || event.key === "Enter") {
                        if (index === enabledFields?.length - 1) {
                          event.preventDefault(); // Prevent default behavior
                          setIsLoadingOverlay(true);
                          if (is_auto_batch) {
                            handleQuantityChange(
                              values?.tempRowData?.item_batch_number,
                              values?.tempRowData?.item_loose_qty,
                              values?.tempRowData,
                              values?.tempRowData?.item_refill_days,
                              values?.tempRowData?.item_shortage_qty,
                              values
                            );
                          } else {
                            calculateItemPriceDetails(values?.tempRowData);
                          }
                        } else {
                          event.preventDefault();
                          if (refillRef?.current) {
                            refillRef.current.focus();
                          } else if (shrtQtyRef?.current) {
                            shrtQtyRef.current.focus();
                          }
                        }
                      }
                    }}
                  />
                </div>
              );
            }

            if (fieldValue === "item_refill_days") {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  className={"max-w-[7%]"}
                >
                  <ItemsInputField
                    type="number"
                    disabled={disabled}
                    ref={refillRef}
                    name={`tempRowData.item_refill_days`}
                    label="Refill Days"
                    isLabelReq={true}
                    placeholder="Refill"
                    onKeyDown={(event) => {
                      if (event.key === "Tab" || event.key === "Enter") {
                        if (index === enabledFields?.length - 1) {
                          event.preventDefault(); // Prevent default behavior
                          setIsLoadingOverlay(true);
                          if (is_auto_batch) {
                            handleQuantityChange(
                              values?.tempRowData?.item_batch_number,
                              values?.tempRowData?.item_loose_qty,
                              values?.tempRowData,
                              values?.tempRowData?.item_refill_days,
                              values?.tempRowData?.item_shortage_qty,
                              values
                            );
                          } else {
                            calculateItemPriceDetails(values?.tempRowData);
                          }
                        } else {
                          event.preventDefault();
                          if (shrtQtyRef?.current) {
                            shrtQtyRef.current.focus();
                          }
                        }
                      }
                    }}
                  />
                </div>
              );
            }

            if (fieldValue === "item_shortage_qty") {
              return (
                <div
                  style={{
                    minWidth: `${widthPercent}%`,
                    maxWidth: `${widthPercent}%`,
                  }}
                  className={"max-w-[7%]"}
                >
                  <ItemsInputField
                    type="number"
                    disabled={disabled}
                    ref={shrtQtyRef}
                    name={`tempRowData.item_shortage_qty`}
                    label="Shortage Qty"
                    isLabelReq={true}
                    placeholder="Shortage"
                    onKeyDown={(event) => {
                      if (
                        event.key === "-" ||
                        event.key === "e" ||
                        event.key === "."
                      ) {
                        event.preventDefault();
                      }
                      if (event.key === "Tab" || event.key === "Enter") {
                        event.preventDefault(); // Prevent default behavior
                        setIsLoadingOverlay(true);
                        if (is_auto_batch) {
                          handleQuantityChange(
                            values?.tempRowData?.item_batch_number,
                            values?.tempRowData?.item_loose_qty,
                            values?.tempRowData,
                            values?.tempRowData?.item_refill_days,
                            event?.target?.value,
                            values
                          );
                        } else {
                          calculateItemPriceDetails(values?.tempRowData);
                        }
                      }
                    }}
                  />
                </div>
              );
            }

            return null;
          })}

          {/* Create New Product Button            // creating extra space on right side
          <div className="flex items-center ml-4">
            <button
              type="button"
              onClick={() => setCreateProductPanelOpen(true)}
              className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors text-sm font-medium"
            >
              <span className="text-lg font-bold">+</span>
              Create New Product
            </button>
          </div> */}
        </div>
      )}

      <div
        style={{
          maxHeight: `calc(100% - ${disabled ? "0rem" : "5.5rem"} )`,
          minHeight: `5rem`,
        }}
        className={`tab-container border-radius ${disabled ? "mt-[1rem]" : ""}`}
      >
        <table className="w-full border-collapse mt-0">
          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
            <tr className="relative h-[50px]">
              {heading
                ?.filter((heading) => heading?.enabled !== false)
                ?.map((heading, index) => (
                  <th
                    style={{ minWidth: `${heading?.minWidth}px` }}
                    key={heading.value || index}
                    className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                  >
                    {heading?.value === "clear_all" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                                ? "center"
                                : "flex-start",
                          width: "100%", // Ensure the div takes full width of the th
                        }}
                      >
                        {!disabled && (
                          <AddButton
                            type="button"
                            onclkFn={() => {
                              if (values?.data?.length > 0) {
                                removeRow(0, "all");
                              }
                            }}
                            prefixIcon={false}
                            text={"Clear All"}
                            className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                          />
                        )}
                      </div>
                    ) : (
                      <div
                        className="flex items-center gap-2 w-full"
                        style={{
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                                ? "center"
                                : "flex-start",
                        }}
                      >
                        {heading?.label}
                      </div>
                    )}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="h-full">
            {values?.data?.map((rowData, rowIndex) => (
              <tr
                className={`hover:bg-[var(--create-table-row-hover-bg)] ${rowIndex % 2 === 0
                    ? " bg-[var(--create-table-row-alt-bg)]"
                    : " bg-[var(--create-table-row-bg)]"
                  }   h-[50px] `}
                key={rowIndex}
              >
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => {
                    return (
                      <td
                        style={{
                          minWidth: `${heading?.minWidth}px`,
                          textAlign: heading?.alignment, // Keep textAlign for normal text cells
                        }}
                        key={heading.value || index}
                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                      >
                        {heading.value === "sl_no" ? (
                          <div>
                            <input
                              type="checkbox"
                              name="SerialNumberRadioGroup"
                              value={rowIndex}
                              className="peer hidden"
                              id={`alt-${rowIndex}`}
                              onChange={() => {
                                if (selectedItem?.index === rowIndex) {
                                  setSelectedItem({
                                    itemid: "",
                                    index: null,
                                    item_name: "",
                                  });
                                } else {
                                  setSelectedItem({
                                    itemid: rowData?.item_id,
                                    item_name: rowData?.item_name,
                                    item_batch_number:
                                      rowData?.item_batch_number,
                                    index: rowIndex,
                                  });

                                  setFieldValue("tempRowData", rowData);
                                }
                              }}
                              checked={selectedItem?.index === rowIndex}
                            />
                            <label
                              htmlFor={`alt-${rowIndex}`}
                              className={`block cursor-pointer select-none border-radius  text-center hover:bg-slate-100 w-[3.5rem] py-[12px] ${selectedItem?.index === rowIndex
                                  ? "font-bold outline-none ring-2 ring-[var(--primary)] bg-[var(--create-table-row-sel-bg)]"
                                  : ""
                                }`}
                            >
                              {rowIndex + 1}
                            </label>
                          </div>
                        ) : heading.value === "item_batch_number" ? (
                          <ChangeBatchField
                            setIsLoadingOverlay={setIsLoadingOverlay}
                            rowIndex={rowIndex}
                            disabled={disabled || !is_auto_batch}
                            rowData={rowData}
                          />
                        ) : heading.value === "clear_all" ? (
                          <button
                            type="button"
                            onClick={() => {
                              removeRow(rowIndex, "");
                            }}
                            style={{
                              display: "flex",
                              justifyContent:
                                heading?.alignment === "right"
                                  ? "flex-end"
                                  : heading?.alignment === "center"
                                    ? "center"
                                    : "flex-start",
                              width: "100%", // Take full width of the td
                            }}
                          >
                            {!disabled && (
                              <DeleteIcon className="cursor-pointer text-red-500" />
                            )}
                          </button>
                        ) : (
                          rowData[heading.value] ?? "--"
                        )}
                      </td>
                    );
                  })}
              </tr>
            ))}
          </tbody>
        </table>
        <LoadingOverlay isLoading={isLoadingOverlay || isbarcodeScanning} />
      </div>
      <BatchSelectionModal
        heading={batchheading || []}
        isOpen={batchModalOpen}
        setIsOpen={setBatchModalOpen}
        batches={values?.tempRowData?.item_Batch_List || []}
        onSelect={(selectedBatch) => {
          if (selectedBatch?.stock_status === "Out of Stock") {
            errorToast("Out of Stock");
          } else {
            console.log(selectedBatch, "dfsfsdfdsfsdfsf");
            const currentBillingBaseQty = values?.tempRowData?.billing_base_quantity;
            const effectivePackSize = currentBillingBaseQty
              ? currentBillingBaseQty
              : parseFloat(selectedBatch?.item_pack_size) || 1;
            const batchQty = parseFloat(selectedBatch?.item_quantity) || 0;
            const updatedTempRowData = {
              ...values?.tempRowData,
              total_sellable_quantity: currentBillingBaseQty
                ? Math.floor(batchQty / currentBillingBaseQty)
                : selectedBatch?.item_quantity ?? 0,
              item_exp_date: selectedBatch?.item_exp_date ?? null,
              item_schedule: selectedBatch?.item_schedule ?? "",
              item_batch_number: selectedBatch?.item_batch_number ?? "",
              item_uom_id: selectedBatch?.item_uom_id ?? "",
              item_uom: currentBillingBaseQty
                ? values?.tempRowData?.item_uom
                : selectedBatch?.item_uom ?? "",
              max_pack_qty: currentBillingBaseQty
                ? Math.floor(batchQty / currentBillingBaseQty)
                : selectedBatch?.item_pack_qty || 0,
              max_loose_qty: currentBillingBaseQty
                ? batchQty % currentBillingBaseQty
                : selectedBatch?.item_loose_qty || 0,
              item_pack_qty: "",
              item_loose_qty: "",
              item_pack_size: effectivePackSize,
              item_unit_price:
                parseFloat(selectedBatch?.item_unit_price) /
                effectivePackSize ?? "",
              item_pack_price: selectedBatch?.item_unit_price ?? "",
              item_batch_final_purchase_rate:
                selectedBatch?.item_batch_final_purchase_rate ?? "",
              item_discount_percentage:
                parseFloat(selectedBatch?.discount_percentage) || "",
              item_gst: selectedBatch?.tax_rate,
              item_total_tax_percentage: selectedBatch?.tax_rate,
              item_selling_price: selectedBatch?.item_selling_price,
              item_rack_location: selectedBatch?.item_rack_location,
              is_store_added_item: false,
            };
            setFieldValue("tempRowData", updatedTempRowData);
            setBatchModalOpen(false);
            setTimeout(() => {
              pack_qty_ref?.current?.focus();
            }, 300);
          }
        }}
      />
    </div>
  );
};

export default BillingItemsSection;
const heading = [
  {
    label: "Sl No",
    value: "sl_no",
    enabled: true,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Item Code",
    value: "item_code",
    enabled: true,
    minWidth: "50",
    alignment: "left",
  },
  {
    label: "Item Name",
    value: "item_name",
    enabled: true,
    minWidth: "70",
    alignment: "left",
  },
  {
    label: "Pack Size",
    value: "item_pack_size",
    enabled: true,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "UOM",
    value: "item_uom",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Batch No.",
    value: "item_batch_number",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Exp. Date",
    value: "item_exp_date",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Pack Qty",
    value: "item_pack_qty",
    enabled: false,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "Loose Qty",
    value: "item_loose_qty",
    enabled: true,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "SCH",
    value: "item_schedule",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "HSN",
    value: "item_hsn",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Unit MRP",
    value: "item_unit_price",
    enabled: true,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "MRP",
    value: "item_pack_price",
    enabled: true,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "Disc. %",
    value: "item_discount_percentage",
    enabled: true,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Disc. Amt",
    value: "item_discount_amount",
    enabled: false,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "Tax %",
    value: "item_gst",
    enabled: true,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Tax Amt",
    value: "item_tax_amount",
    enabled: true,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "Final Price",
    value: "item_final_price",
    enabled: true,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "Margin %",
    value: "item_margin_percentage",
    enabled: true,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Avail. Qty",
    value: "total_sellable_quantity",
    enabled: true,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Quantity",
    value: "quantity",
    enabled: false,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Free Qty",
    value: "item_free_quantity",
    enabled: false,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Location",
    value: "item_rack_location",
    enabled: false,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Mfg. Name",
    value: "item_manufacturer_name",
    enabled: false,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Price",
    value: "item_price_wiithout_tax",
    enabled: true,
    minWidth: "10",
    alignment: "left",
  },
  {
    label: "Refill Days",
    value: "item_refill_days",
    enabled: false,
    minWidth: "5",
    alignment: "left",
  },
  {
    label: "Total Amt.",
    value: "item_total_amount",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Product Input",
    value: "",
    enabled: true,
    minWidth: "20",
    alignment: "left",
  },
  {
    label: "Clear All",
    value: "clear_all",
    enabled: true,
    minWidth: "10",
    alignment: "center",
  },
];
